import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AccessControlService } from 'src/app/services/access-control.service';
import { UtilityService } from 'src/app/services/utility.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-multifactor-auth',
  templateUrl: './multifactor-auth.component.html',
  styleUrls: ['./multifactor-auth.component.css']
})
export class MultifactorAuthComponent implements OnInit {

  constructor(private accessControlService: AccessControlService,
    private utilityService: UtilityService, private toastrService: ToastrService) { }
  isMfaOn: boolean = false;
  isPhoneMFa: boolean = false;
  isEmailMFa: boolean = false;
  dropdownSettings = {
    singleSelection: false,
    idField: '_id',
    textField: 'application_name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 5,
    allowSearchFilter: false
  };
  applications: [{ _id: any, application_name: any }];
  phoneMfaApps: any = [];
  emailMfaApps: any = [];
  clientId = localStorage.getItem("org_id");
  isLoading:boolean;

  ngOnInit() {
    this.accessControlService.getClientAppsWithMinDetails(this.clientId).subscribe((response: any) => {
      if (!response.error)
        this.applications = response.data.applications;
      this.getMfaDetails();
    })
  }

  onFactorToggle(event, target) {
  }
  onMFaToggle(event) {
    if (!event) {
      this.isPhoneMFa = false;
      this.isEmailMFa = false;
    }
    this.enableMFA(event);
  }
  enableMFA(event) {
    this.utilityService.enableMFA({ clientId: this.clientId, allowMfa: event }).subscribe((res: any) => {
      if (!res.error) {
        this.toastrService.success(res.message);
      }
    }, errror => {
      this.toastrService.error(errror.error);

    })
  }
  addUpdateMfa(factorType: any) {
    let apps = [];
    if (factorType == "PHONE") {
      apps = this.phoneMfaApps;
    } else
      apps = this.emailMfaApps;
    this.utilityService.addOrUpdateMFA({ clientId: this.clientId, factor: factorType, apps: apps }).subscribe((res: any) => {
      if (!res.error)
        this.toastrService.success(res.message);

    }, errror => {
      this.toastrService.error(errror.error);

    })
  }
  getMfaDetails() {
    this.isLoading=true
    this.utilityService.getMfaList(this.clientId).subscribe((res: any) => {
      if (!res.error) {
        {
          this.isMfaOn = res.data.isMfaEnabled || false;
          if (res.data.phone.length > 0) {
            this.phoneMfaApps = res.data.phone.map(x => {
              return this.applications.find(z => z._id == x._id)
            });;
            this.isPhoneMFa = this.isMfaOn ? true : false;

          }
          if (res.data.email.length > 0) {
            this.isEmailMFa = this.isMfaOn ? true : false;
            this.emailMfaApps = res.data.email.map(x => {
              return this.applications.find(z => z._id == x._id)
            });
          }

        }

      }
      this.isLoading=false
    },
    (err)=>{this.isLoading=false})
  }
  onFactorChange(event: any, factor: any) {
    if (!event) {
      let apps : any[];
      apps = (factor == "PHONE") ? this.phoneMfaApps : this.emailMfaApps;
      this.utilityService.removeAllAppFromMFA({ clientId: this.clientId, apps: apps, factor: factor }).
        subscribe((res: any) => {
          if (!res.error) {
            this.toastrService.success(res.message);
            if (factor == "PHONE")
              this.phoneMfaApps = [];
            else
              this.emailMfaApps = [];
          }
        }, (error: HttpErrorResponse) => {
          this.toastrService.error(error.statusText)
        })
    }
  }
  onDeSelect(item: any, factor: any) {
    Swal({
      title: `Are you sure you want to remove ${item.application_name}?`,
      text: "You won't be able to revert this!",
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, remove it!'
    }).then((result) => {
      if (result.value) {
        this.utilityService.removeAppFromMFA({ clientId: this.clientId, appId: item._id, factor: factor }).subscribe((res: any) => {
          if (!res.error) {
            this.toastrService.success(`${item.application_name} removed successfully`)
          }
        }, error => {
          this.toastrService.error(error.statusText)
        })
      } else {
        switch (factor) {
          case "PHONE":
            this.phoneMfaApps.push(item);
            break;
          case "EMAIL":
            this.emailMfaApps.push(item);
            break;
        }

      }
    })
  }
}
